import { render, staticRenderFns } from "./PublicBannerSection.vue?vue&type=template&id=ddc0b048"
import script from "./PublicBannerSection.vue?vue&type=script&lang=ts"
export * from "./PublicBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./PublicBannerSection.vue?vue&type=style&index=0&id=ddc0b048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports